import * as React from "react";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { IconButton } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import { useAuth } from "../../contexts/AuthContext";
import { useAutoUpdate } from "../../contexts/AutoUpdateContext";
import { Logout } from "../../services/api/logout";
import { logoURL } from "../../theme";
import AvatarInitials from "../user/AvatarInitials";
import EnvironmentBadge from "./EnvironmentBadge";
import ThemeModeSwitch from "./ThemeModeSwitch";

const Header: React.FC = () => {
  const { currentUser } = useAuth();
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const autoUpdate = useAutoUpdate();

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    Logout.logout()
      .then(() => {
        autoUpdate.setActive(false);
        currentUser.logout();
      })
      .then(() => window.location.assign("https://login.inbcu.com/login/logoff.jsp"));
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ backgroundColor: "black" }} elevation={0}>
        <EnvironmentBadge />
        <Toolbar>
          <IconButton>
            <img src={logoURL} alt="logo" style={{ height: 50, width: 50 }} />
          </IconButton>
          <Typography variant="h6" style={{ fontWeight: "bold" }}>
            Ad Transcode Pipeline
          </Typography>
          <div style={{ flexGrow: 1 }}></div>
          <ThemeModeSwitch />
          <Box>
            <IconButton onClick={handleOpenUserMenu}>
              {currentUser.first_name && currentUser.last_name ? (
                <AvatarInitials
                  firstName={currentUser.first_name}
                  lastName={currentUser.last_name}
                  size={"medium"}
                />
              ) : (
                <AccountCircleIcon fontSize="medium" style={{ color: "white" }} />
              )}
            </IconButton>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem disabled>
                {currentUser.first_name} {currentUser.last_name} ({currentUser.role})
              </MenuItem>

              <MenuItem onClick={handleLogout}>
                Logout
                <ExitToAppIcon sx={{ paddingLeft: 1 }} />
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};
export default Header;
